import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
    getAuctionGrades,
    getAuctionGrade,
    createAuctionGrade,
    editAuctionGrade,
    deleteAuctionGrade,
} from "api/auctionGradeApi";

export const AUCTION_GRADE_QUERY_KEY = "auction-grades";

export const useAuctionGrades = (params = {}, enabled = true) => {
  return useQuery({
    queryKey: [AUCTION_GRADE_QUERY_KEY, params],
    queryFn: () => getAuctionGrades(params),
    keepPreviousData: true,
    enabled
  });
};

export const useAuctionGrade = (id) => {
  return useQuery({
    queryKey: [AUCTION_GRADE_QUERY_KEY, id],
    queryFn: () => getAuctionGrade(id),
    enabled: !!id,
  });
};

export const useCreateAuctionGrade = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createAuctionGrade,
    onSuccess: () => queryClient.invalidateQueries([AUCTION_GRADE_QUERY_KEY]),
  });
};

export const useEditAuctionGrade = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: editAuctionGrade,
    onSuccess: () => queryClient.invalidateQueries([AUCTION_GRADE_QUERY_KEY]),
  });
};

export const useDeleteAuctionGrade = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteAuctionGrade,
    onSuccess: () => queryClient.invalidateQueries([AUCTION_GRADE_QUERY_KEY]),
  });
};
